import React from 'react';
import { useParams } from 'react-router';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItemText, ListItem } from '@material-ui/core';
import ConversationListItem from './ConversationListItem';

import { useTranslation } from 'react-i18next';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid rgba(0,0,0,0.1)'

  },
  searchInput: {
    flexGrow: 1
  }
}));

function ConversationList({ getData, conversations, className, ...rest }) {
  const classes = useStyles();
  const params = useParams();
  const { t } = useTranslation('overview');
  const selectedConversation = params.id;
  return (
    <div
      className={clsx(classes.root, className)}
    >
      <List
        disablePadding
        subheader={(
          <ListItem style={{borderBottom: '1px solid rgba(0,0,0,0.1)',padding: 15}}>
            <ListItemText primary={t('lblChat')} secondary={' '} />
          </ListItem>

        )}
      >
        {conversations.map((conversation, i) => (
          <ConversationListItem
            getData={getData}
            active={conversation.id === selectedConversation}
            conversation={conversation}
            divider={i < conversations.length - 1}
            key={conversation.id}
          />
        ))}
      </List>
    </div>
  );
}

ConversationList.propTypes = {
  className: PropTypes.string,
  conversations: PropTypes.array.isRequired
};

export default ConversationList;
